import LandingPage from "../pages/LandingPage";

const BaseRoutes = {
    path: '/',
    element: <LandingPage />
}

export default BaseRoutes;